var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpluslang(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 147.85 147.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#662d91;}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 147.85,
    height: 147.85
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    className: "cls-3",
    d: "M132.18,147.85H15.67A15.64,15.64,0,0,1,0,132.25H0V15.6A15.63,15.63,0,0,1,15.67,0H132.18a15.63,15.63,0,0,1,15.67,15.6V132.25a15.64,15.64,0,0,1-15.67,15.6",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    className: "cls-4",
    d: "M81.82,58.71,63.57,62a13.18,13.18,0,0,0-4.19-8.2A12.7,12.7,0,0,0,50.92,51a13.9,13.9,0,0,0-11,4.76q-4.11,4.76-4.11,15.91,0,12.39,4.18,17.51a13.79,13.79,0,0,0,11.24,5.12,12.49,12.49,0,0,0,8.63-3q3.36-3,4.74-10.26l18.19,3.08Q79.91,96.63,71.88,103t-21.55,6.36q-15.36,0-24.48-9.64T16.71,73q0-17.25,9.16-26.86t24.78-9.61Q63.43,36.54,71,42t10.84,16.7",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    className: "cls-4",
    d: "M88.67,85.91v-9H79.51V70.63h9.16v-9h6.1v9H104v6.24H94.77v9Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    className: "cls-4",
    d: "M117.18,85.91v-9H108V70.63h9.15v-9h6.11v9h9.18v6.24h-9.18v9Z",
    transform: "translate(0 0)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpluslang);
export default __webpack_public_path__ + "static/media/cpluslang.d3b7545fc833d525663d260928072509.svg";
export { ForwardRef as ReactComponent };